"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileSelectDropzone = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_device_detect_1 = require("react-device-detect");
var react_dropzone_1 = __importDefault(require("react-dropzone"));
var react_redux_1 = require("react-redux");
require("./FileSelectDropzone.scss");
require("../../eventManager");
var eventManager_1 = require("../../eventManager");
var pluginActions_1 = require("../../pluginActions");
var log_1 = __importDefault(require("@app/shared/log"));
var utils_1 = require("@app/shared/utils");
var initialState = {
    connectAttached: false,
    gatewayAttached: false
};
var FileSelectDropzone = /** @class */ (function (_super) {
    __extends(FileSelectDropzone, _super);
    function FileSelectDropzone() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = initialState;
        _this.handleDrop = function (accepted) { return __awaiter(_this, void 0, void 0, function () {
            var filesOnly, _i, accepted_1, file, isFileADirectory, files;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.props.httpGatewayStatus) return [3 /*break*/, 5];
                        filesOnly = [];
                        _i = 0, accepted_1 = accepted;
                        _a.label = 1;
                    case 1:
                        if (!(_i < accepted_1.length)) return [3 /*break*/, 4];
                        file = accepted_1[_i];
                        return [4 /*yield*/, utils_1.isDirectory(file)];
                    case 2:
                        isFileADirectory = _a.sent();
                        if (!isFileADirectory) {
                            filesOnly.push(file);
                        }
                        _a.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4:
                        files = filesOnly.map(function (f) {
                            return {
                                filename: f.name,
                                path: '',
                                size: f.size,
                                type: f.type,
                                fileData: f
                            };
                        });
                        this.props.onSelect(files);
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.handleClick = function (event) {
            if (_this.props.pluginEnabled) {
                event.preventDefault();
                event.stopPropagation();
                eventManager_1.eventManager.emit(pluginActions_1.SHOW_SELECT_FILE_DIALOG);
            }
            else {
                if (_this.props.httpGatewayStatus) {
                    log_1.default.debug('SELECTING FILES FOR UPLOAD VIA HTTP GATEWAY');
                    event.preventDefault();
                    event.stopPropagation();
                    eventManager_1.eventManager.emit(pluginActions_1.SELECT_FILES_FOR_UPLOAD);
                }
                else {
                    log_1.default.debug('SELECTING FILES FOR UPLOAD VIA PLUGINLESS');
                }
            }
        };
        _this.handleFolderClick = function (event) {
            if (_this.props.pluginEnabled) {
                event.preventDefault();
                event.stopPropagation();
                eventManager_1.eventManager.emit(pluginActions_1.SHOW_SELECT_FOLDER_DIALOG);
            }
        };
        return _this;
    }
    FileSelectDropzone.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.props.pluginEnabled && !this.state.connectAttached) {
                    eventManager_1.eventManager.emit(pluginActions_1.ATTACH_DRAG_AND_DROP, '.dropzone');
                    this.setState(__assign(__assign({}, this.state), { connectAttached: true }));
                }
                else {
                    if (this.props.httpGatewayStatus && this.props.className === 'gateway-select-dropzone' && !this.state.gatewayAttached) {
                        eventManager_1.eventManager.emit(pluginActions_1.DROP_FILES_FOR_UPLOAD, '.gateway-select-dropzone');
                        this.setState(__assign(__assign({}, this.state), { gatewayAttached: true }));
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    FileSelectDropzone.prototype.componentDidUpdate = function (prevProps) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.props.pluginEnabled !== prevProps.pluginEnabled || this.props.httpGatewayStatus !== prevProps.httpGatewayStatus) {
                    if (this.props.pluginEnabled && !this.state.connectAttached) {
                        eventManager_1.eventManager.emit(pluginActions_1.ATTACH_DRAG_AND_DROP, '.dropzone');
                        this.setState(__assign(__assign({}, this.state), { connectAttached: true }));
                    }
                    else {
                        if (this.props.httpGatewayStatus && this.props.className === 'gateway-select-dropzone' && !this.state.gatewayAttached) {
                            eventManager_1.eventManager.emit(pluginActions_1.DROP_FILES_FOR_UPLOAD, '.gateway-select-dropzone');
                            this.setState(__assign(__assign({}, this.state), { gatewayAttached: true }));
                        }
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    FileSelectDropzone.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, pluginEnabled = _a.pluginEnabled;
        return (react_1.default.createElement(react_dropzone_1.default, { onDrop: this.handleDrop }, function (_a) {
            var getRootProps = _a.getRootProps, getInputProps = _a.getInputProps, isDragActive = _a.isDragActive;
            var dropzoneClass = classnames_1.default(className, { 'is-active': (_this.props.isDragActive || isDragActive) });
            return (react_1.default.createElement("div", __assign({}, getRootProps({
                className: dropzoneClass,
                onClick: _this.handleClick
            })),
                react_1.default.createElement("input", __assign({}, getInputProps())),
                react_1.default.createElement("div", { className: "download-icon" },
                    react_1.default.createElement("i", { className: "fas fa-cloud-upload-alt fa-6x has-text-info" })),
                react_1.default.createElement("p", { className: "is-size-4-desktop has-text-centered" }, pluginEnabled ? (react_1.default.createElement("span", null,
                    "Drag and drop files",
                    !react_device_detect_1.isIE ? ' and folders ' : ' ',
                    "here, or just click to browse ",
                    react_1.default.createElement("a", { onClick: _this.handleClick }, "files"),
                    " or ",
                    react_1.default.createElement("a", { onClick: _this.handleFolderClick }, "folders"))) : (react_1.default.createElement("span", null,
                    "Drag and drop files here, or just ",
                    react_1.default.createElement("span", { className: "has-text-info has-cursor-pointer" }, "click"),
                    " to browse files")))));
        }));
    };
    return FileSelectDropzone;
}(react_1.Component));
exports.FileSelectDropzone = FileSelectDropzone;
var mapStateToProps = function (state) {
    return {
        httpGatewayStatus: state.transfers.httpGatewayStatus,
        isDragActive: state.ui.isUploadDragActive
    };
};
exports.default = react_redux_1.connect(mapStateToProps)(FileSelectDropzone);
